<template>
  <div class="chart-section">
    <portfolioHealth :interval-chart="1000"/>
  </div>
</template>

<script>
import portfolioHealth from '@/components/portfolioHealth.vue';

export default {
    name: 'componentTester',
    components: { portfolioHealth },
}
</script>

<style>
.chart-section {
  height: 1200px !important;
}
</style>
